const tag = {
    display: `inline-flex`,
    borderRadius: `full`,
    fontWeight: `normal`,
    textDecoration: `none`,
    verticalAlign: `middle`,
    transition: ` all 250ms ease`,
    cursor: `pointer`,
    lineHeight: 1,
    px: 3,
    py: 2,
    bg: `omegaLight`,
    color: `text`,
    ':hover': {
      bg: `alpha`,
      color: `white`
    }
}

export default tag